import React, { memo } from 'react'
import { usePopperTooltip } from 'react-popper-tooltip'
import clsx from 'clsx'

import styles from './styles.module.scss'

interface ITooltipProps extends React.HTMLAttributes<HTMLElement> {
  placement?: 'top' | 'right' | 'bottom' | 'left'
  text?: string | React.ReactNode
  eventTriggers?: string[]
}

function Tooltip({
  text,
  placement = 'right',
  eventTriggers = ['click', 'hover'],
  children,
  className,
}: ITooltipProps) {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({
    placement,
    trigger: eventTriggers as any,
  })

  return (
    <>
      <span ref={setTriggerRef} className={styles['tooltip-trigger']}>
        {children}
      </span>
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({
            className: clsx(styles.tooltipContainer, className),
          })}
        >
          <div
            {...getArrowProps({
              className: clsx(styles.tooltipArrow, 'text'),
            })}
          />
          {text}
        </div>
      )}
    </>
  )
}

export default memo(Tooltip)
